import {IToJson} from '@toolify/client/src/types/IToJson'

import {
  IWorkspaceMemberResponseInstance,
} from '@toolify/server/src/controllers/WorkspaceMemberController/types/IWorkspaceMemberResponseInstance'
import {mapResponseEntity} from '@toolify/client/src/modules/api/singletons/mapResponseEntity'

export function mapWorkspaceMemberResponseInstance(
  workspaceMember: IToJson<IWorkspaceMemberResponseInstance>,
): IWorkspaceMemberResponseInstance {
  return {
    ...workspaceMember,
    entity: mapResponseEntity(workspaceMember.entity),
  }
}
